import Heading from '@eversports/klimt-primitives/legacy/Heading'

import type { Meta } from '../../../App.types'
import MetaHelmet from '../../../components/MetaHelmet'
import { Localized } from '../../../localization/react'
import type { Venue } from '../VenueProfile.types'

import { VenueVouchersBanner } from './Vouchers/VenueVouchersBanner'

interface Props {
  venue: Venue
  meta: Meta
}

export function VenueVouchers({ venue, meta }: Props) {
  return (
    <>
      <MetaHelmet noIndex meta={meta} />
      <Heading
        is="h1"
        sx={{ mt: 4, mb: 12, fontSize: 40, textAlign: 'left', lineHeight: 1, paddingX: { xs: 4, lg: 0 } }}
      >
        <Localized
          id="venue-vouchers-page-title"
          params={{ venueName: venue.name, district: `${venue.location.zip} ${venue.location.city}` }}
        />
      </Heading>
      <VenueVouchersBanner
        name={venue.name}
        voucherWidgetUrl={venue.voucherWidgetUrl}
        hasMultipleBranches={venue.company.venues.some((companyVenue) => companyVenue.id !== venue.id)}
      />
    </>
  )
}
